import { render, staticRenderFns } from "./UserAccountTab.vue?vue&type=template&id=5b63d880&scoped=true&"
import script from "./UserAccountTab.vue?vue&type=script&lang=ts&"
export * from "./UserAccountTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63d880",
  null
  
)

export default component.exports